import { render, staticRenderFns } from "./PassengerSeatMapReturn.vue?vue&type=template&id=4d70a076&"
import script from "./PassengerSeatMapReturn.vue?vue&type=script&lang=js&"
export * from "./PassengerSeatMapReturn.vue?vue&type=script&lang=js&"
import style0 from "./PassengerSeatMapReturn.vue?vue&type=style&index=0&id=4d70a076&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports